module.exports = __webpack_public_path__ + "349b4f3be6bd99d8811bede284b37e91.jpg";


//////////////////
// WEBPACK FOOTER
// ./web/images/faces/barcelona.jpg
// module id = 593
// module chunks = 0